"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _gatsby = require("gatsby");

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _styles = require("@material-ui/core/styles");

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap'
    },
    chip: {
      margin: theme.spacing.unit
    }
  };
};

var DocTags =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DocTags, _Component);

  function DocTags() {
    (0, _classCallCheck2.default)(this, DocTags);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DocTags).apply(this, arguments));
  }

  (0, _createClass2.default)(DocTags, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tags = _this$props.tags,
          classes = _this$props.classes;
      return _react.default.createElement("div", {
        className: classes.root
      }, tags && tags.map(function (tag) {
        return _react.default.createElement(_gatsby.Link, {
          key: tag,
          style: {
            textDecoration: 'none'
          },
          to: "/tags/".concat(_lodash.default.kebabCase(tag))
        }, _react.default.createElement(_Chip.default, {
          label: tag,
          className: classes.chip
        }));
      }));
    }
  }]);
  return DocTags;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(DocTags);

exports.default = _default;